import React from "react";
import RequestDetailModal from "./RequestDetailModal";

const PassportModal = (props) => <RequestDetailModal {...props} />;

export default PassportModal;
